import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import {red} from '@material-ui/core/colors';
import {Container} from "react-bootstrap";
import Grid from "@material-ui/core/Grid";
import {Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        // width: '50%',
        padding: '50px 50px',
    },

    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    formControl: {
        padding: '15px 0',
        margin: theme.spacing(3),
    }
}));

const UVT_EXAM =[
    {
        question: "Las funciones cuyas gráficas son líneas rectas que pasan por el origen de coordenadas reciben el\n" +
            "nombre de",
        options: [
            {description: "Funciones afines"},
            {description: "Funciones constantes"},
            {description: "Funciones lineales"},
        ]
    },
    {
        question: "La función de proporcionalidad directa recibe el nombre de:",
        options: [
            {description: "Funciones afines"},
            {description: "Funciones constantes"},
            {description: "Funciones lineales"},
        ]
    },
    {
        question: "La función lineal que pasa por el punto (3,6) tiene como expresión:",
        options: [
            {description: "y = 3x+6"},
            {description: "y = 6x–3"},
            {description: "y = 2x"},
        ]
    },
    {
        question: "Si la pendiente de una función lineal es positiva, la función es:",
        options: [
            {description: "Creciente."},
            {description: "Decreciente."},
            {description: "Constante."},
        ]
    },
    {
        question: "Si la pendiente de una función es cero, la función es:",
        options: [
            {description: "Creciente."},
            {description: "Decreciente."},
            {description: "Constante."},
        ]
    },
    {
        question: "La función que pasa por los puntos (1, 3) y (-1, 3) es una:",
        options: [
            {description: "Función afín."},
            {description: "Función constante."},
            {description: "Función lineal."},
        ]
    },
    {
        question: "Dos funciones tienen gráficas representadas por líneas paralelas cuando:",
        options: [
            {description: "Tienen la misma pendiente."},
            {description: "Tienen la misma ordenada en el origen."},
            {description: "Cortan al eje X en el mismo punto."},
        ]
    },
    {
        question: "La función afín que pasa por los punto (2, 5) y (-1,7) es:",
        options: [
            {description: "Creciente."},
            {description: "Decreciente."},
            {description: "Constante."},
        ]
    },
]

export default function Exam(props) {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);


    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Container className={classes.root}>
            <Typography variant="h3" style={{padding: '0 0 50px 50px'}}>
                Examen de Módulo
            </Typography>
            <Grid container justify="center">
                {UVT_EXAM.map((o, index) => {
                    return (
                        <Grid item xs={10} style={{paddingBottom: '50px'}}>
                            <Card>
                                <CardHeader
                                    avatar={
                                        <Avatar aria-label="recipe" className={classes.avatar}>
                                            {index}
                                        </Avatar>
                                    }
                                    title={`Pregunta ${index + 1}/${UVT_EXAM.length}`}
                                    subheader={new Date().toLocaleString('es-ES')}
                                />
                                <CardContent>
                                    <Typography paragraph>{o.question}</Typography>
                                    <FormControl required component="fieldset"
                                                 className={classes.formControl}>
                                        <FormLabel component="legend">Selecciona por lo menos una respuesta</FormLabel>
                                        <FormGroup>
                                            {o.options.map(a => {
                                                return (
                                                    <FormControlLabel
                                                        control={<Checkbox name="gilad"/>}
                                                        label={a.description}
                                                    />
                                                );
                                            })}
                                        </FormGroup>
                                    </FormControl>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Container>
    );
}
